export const CODE_BLOCK_TYPE = 'code-block';
